export const COMPARE_COMPETITOR_TABLE_APPEARANCES = {
  adtBlu: "adtBlu",
  adt: "adt",
} as const;

export type CompareCompetitorTableAppearance =
  (typeof COMPARE_COMPETITOR_TABLE_APPEARANCES)[keyof typeof COMPARE_COMPETITOR_TABLE_APPEARANCES];

export const COMPARE_COMPETITOR_TABLE_DEFAULTS = {
  sectionId: "how-adt-blu-compares",
  appearance: COMPARE_COMPETITOR_TABLE_APPEARANCES.adtBlu,
  ctaLabel: "Shop Now",
} as const;

/** Offset for fixed header when using native in-page anchor scroll. */
export const COMPARE_COMPETITOR_TABLE_SCROLL_MARGIN_TOP_PX = 130;
